<template>
  <div class="rule">
    <div class="mt-4">
      <div class="l-title bold t-center">活动名称</div>
      <div class="l-con bold mt-2 py-2">
        “我最喜爱的图书”投票评选暨96小时惠民书屋活动
      </div>
    </div>
    <div class="mt-5">
      <div class="l-title bold t-center">活动时间</div>
      <div class="l-con mt-2">
        <span class="bold">线上投票：</span>8月12日——8月18日，市民通过投票在50本精选图书中选出10本或进行好书自荐。
      </div>
      <div class="l-con mt-5">
        <span class="bold">线下购书：</span>8月20日——9月30日，市民可凭“特惠购书券”到完美金鹰广场正门旁（星巴克门口旁）第十三届中山书展惠民书屋进行图书选购。
      </div>
    </div>
    <div class="mt-5">
      <div class="l-title bold t-center">活动规则</div>
      <div class="l-con mt-2">
        一、组委会精选出50本图书，市民按照“主题教育图书”、“本土教育图书”、“少儿图书”、“经典图书”和“自荐图书”5个类别分别进行投票。每个类别至少需要投票1本，每个ID需要至少投5本（含自荐图书）。
      </div>
      <div class="l-con mt-5">
        二、“我最喜爱的图书”书单里，市民可选“我要荐书”，填写图书名称，荐书人姓名和推荐理由等信息，组委会对荐书内容进行审核，审核合规后才会发布。
      </div>
      <router-link to="/recommend">
        <div class="btn mt-4">立即荐书</div>
      </router-link>
      <div class="l-con mt-8">
        三、投票完成后，填写个人信息，即可获得“特惠购书券”电子券，每人只限领取一张。
      </div>
      <div class="l-con mt-5">
        四、组委会根据“我最喜爱的图书”投票数量，选出前10本图书作为“特惠购书券”书单。（含每个类别top1图书）
      </div>
      <div class="l-con mt-5 mb-5">
        五、在活动期间，市民凭特惠购书券可到完美金鹰广场正门旁（星巴克门口旁）第十三届中山书展惠民书屋购买相应的图书最多五本，以图书定价的10%结算，图书数量有限，先到先得。
      </div>
      <div class="l-con mt-5 mb-5">
        六、本活动组委会咨询电话0760-88367862。
      </div>
      <div class="l-con mt-5 mb-5">
        七、活动最终解释权归活动组委会所有。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rule',
  data() {
    return {

    }
  }
}
</script>
<style scoped>
.rule {
  padding: 4.6vw;
}
.l-title {
  background-color: #7ecef4;
  color: #003567;
  height: 8vw;
  line-height: 8vw;
}
.l-con {
  font-size: 3.6vw;
  color: #333;
  padding: 0 2vw;
  text-align: justify;
}
</style>